// The i18next singleton, which src/i18n initializes at startup. Importing src/i18n here would run
// that initialization in every module that copies, and break each spec that mocks react-i18next.
import i18next from "i18next";

import { showGlobalToast } from "./showGlobalToast";

/**
 * Write `text` to the clipboard and answer whether the browser took it (PREC-4394).
 *
 * `navigator.clipboard.writeText` rejects when the page lacks focus or the browser denies write
 * permission, and is absent outside a secure context. The 17 call sites this replaced neither
 * awaited nor caught it, so they showed "Copied" for text that never reached the clipboard and
 * left an unhandled rejection behind (Bugsink SIGNALIST-104). A refusal now shows an error toast,
 * and a caller shows its own "Copied" only when this resolves true. Never rejects.
 */
export async function copyText(text: string): Promise<boolean> {
	try {
		await navigator.clipboard.writeText(text);

		return true;
	} catch {
		showGlobalToast(i18next.t("errors.copyFailed"));

		return false;
	}
}
